export const BOOT_START = performance.now();
